import { appAxiosInstance } from "../../api";
import {IGetNotificationsHistory, INotification} from "../../types";
import s from './NotificationList.module.css';
import { Loader } from "../../components/Loader/loader";
import {useNavigate} from "react-router-dom";

interface INotificationListProps {
    notifications: INotification[];
    isLoading: boolean;
    onNotificationRead: () => void;
}

export default function NotificationList({notifications, isLoading, onNotificationRead}: INotificationListProps): JSX.Element {

    const navigate = useNavigate();

    const clickToNotification = async (notification: INotification) => {
        await readNotification(notification.id);
        await onNotificationRead();

        if (notification.clothId) {
            navigate(`/details/${notification.clothId}`);
        }
    };

    const readNotification = async (id: number)=> {
        try {
            await appAxiosInstance.post<IGetNotificationsHistory>(
                '/mobile/readNotification',
                null,
                {
                    params: { id }
                }
            );
        } catch (error) {
            console.error('Ошибка при отметке уведомления:', error);
        }
    };

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffTime = Math.abs(now.getTime() - date.getTime());
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays === 0) {
            return 'Сегодня';
        } else if (diffDays === 1) {
            return 'Вчера';
        } else {
            return date.toLocaleDateString('ru-RU', {
                day: 'numeric',
                month: 'short'
            });
        }
    };

    return (
        <div className={s.container}>
            <div className={s.header}>
                <h3 className={s.title}>Уведомления</h3>
            </div>

            {isLoading ? (
                <div className={s.loaderWrapper}>
                    <Loader/>
                </div>
            ) : (
                notifications.length > 0 ? (
                    <div className={s.list}>
                        {notifications.map((notification, index) => (
                            <div
                                key={index}
                                onClick={() => clickToNotification(notification)}
                                className={`${s.notification} ${!notification.isRead ? s.unread : ''}`}
                            >
                                <div className={s.notificationContent}>
                                    <div className={s.notificationHeader}>
                                        <span className={s.notificationTitle}>
                                            {notification.title}
                                        </span>
                                        <span className={s.notificationDate}>
                                            {formatDate(notification.sendingDate)}
                                        </span>
                                    </div>
                                    <p className={s.notificationMessage}>
                                        {notification.message}
                                    </p>
                                </div>
                                {!notification.isRead && <span className={s.unreadDot} />}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={s.emptyState}>
                        <p>Нет уведомлений</p>
                    </div>
                )
            )}
        </div>
    );
}